module.exports = __webpack_public_path__ + "media/customizations/newfield/logo-aa58ea29e9a372fc16045ef225e7681f.png";